import { render, staticRenderFns } from "./OurTeam.vue?vue&type=template&id=12b385a2&"
import script from "./OurTeam.vue?vue&type=script&lang=js&"
export * from "./OurTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/local/share/application/maren/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('12b385a2', component.options)
    } else {
      api.reload('12b385a2', component.options)
    }
    module.hot.accept("./OurTeam.vue?vue&type=template&id=12b385a2&", function () {
      api.rerender('12b385a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/static/OurTeam.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/static/OurTeam.vue
// module id = 517
// module chunks = 4